// removed by extract-text-webpack-plugin
module.exports = {"New_bg_01":"_1kmLAu6JHKBSUtO7oHnu86","New_zhengzhou_box":"_3ddDopXTUtLOm7zOffAY06","New_logo_top":"HYrffadoOeMGunjwj91CR","New_wap_bottom":"SgI-5k-54divZbgtH3Get","New_wap_left":"_38s0GhND_hMIckO0X_j2g","miss":"_3z8MtHXkC_uBp7mIjrK7Q2","New_profile":"_1vbXSZd5BwJT6K7E3G-m14","New_button_ul":"_305TWj2R4SFuOfxC9GFFh7","New_logo_title_one":"_3LAiDUMTm9nGMpLsDuE0YR","New_build":"_14-Vw9Fi6Oo0Nonqx5FbF-","ComeIn":"_16EoMw2nzTwQy31hcyJUx_","New_scale":"_1tjidSHYwKKsWgqn-ePzUK","New_profile_address":"_1nIjf0O6Hts6JDrowleo23","New_map":"XYUjs0rfE9TDySUo2it73","New_wap_right":"_3NKRnVt7EaG5HA_MaIENQb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ZhenzhouGongMei/ZhenzhouGongMei.scss
 ** module id = 1104
 ** module chunks = 0
 **/